export default "__VITE_ASSET__cad2198d__"